<template>
  <transition name="zoom">
    <div class="page-content">
      <el-card
               v-loading="loading"
               class="page-box detail-box"
               shadow="never">
        <div slot="header" class="clearfix">
          <div class="title">通知详情</div>
          <span class="close"  @click="$emit('org-inform-view','inform-list')">
            <icon-svg iconClass="close-small"></icon-svg>
          </span>
        </div>
        <div class="appl-info">
          <el-form
            :model="formData"
            ref="form"
            label-width="100px"
            v-loading="loading"
          >
            <el-form-item label="标题名称：" prop="title">
              <el-input type="text" v-model="formData.title" placeholder="标题" class="el-input" readonly ></el-input>
            </el-form-item>
            <el-form-item label="通知类型：" prop="type">
              <el-select v-model="formData.type" placeholder="请选择通知类型" class="el-select" disabled>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!--<el-form-item label="通知内容：" prop="content">-->
              <!--<div v-html="formData.content"></div>-->
              <!---->
            <!--</el-form-item>-->
            <el-form-item label="通知内容：" prop="content">
              <quill-editor v-loading="loading"
                            class="content-des"
                            v-model="formData.content"
                            ref="basicQuillEditor"
                            :options="editorOption" readonly>
              </quill-editor>
              <el-upload
                class="avatar-uploader"
                id="basic-uploader"
                accept="image"
                :show-file-list="false" disabled>
              </el-upload>
            </el-form-item>
            <div class="tc">
              <el-button
                style="width: 140px"
                v-on:click="goBack">关闭
              </el-button>
            </div>
          </el-form>
        </div>
      </el-card>
    </div>
  </transition>
</template>

<script>
import {orgInform} from '../../api'
export default {
  name: 'orgInformDetail',
  components: {},
  props: {
    param: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      options: [{label: '员工通知', value: '1'}, {label: '会员通知', value: '2'}],
      formData: {
        informId: '',
        createUser: this.$store.state.user.userId,
        orgCode: this.$store.state.user.orgCode,
        content: '',
        title: '',
        type: ''
      },
      editorOption: {
        placeholder: '请填写通知内容',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              [{'header': [1, 2, 3, 4, 5, 6, false]}],
              [{'color': []}, {'background': []}], // dropdown with defaults from theme
              [{'font': []}],
              [{'align': []}],
              ['link']
            ]
          }
        }
      }
    }
  },
  created () {
  },
  methods: {
    changeEvent (value) {
      this.getData(value)
      this.$refs.basicQuillEditor.quill.enable(false)
    },
    async getData (value) {
      this.loading = true
      let {data} = await orgInform.getDateil(value)
      this.formData = data
      this.loading = false
    },
    goBack () {
      this.$emit('org-inform-view', 'inform-list')
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-content {
    background-color: #fff;
  }
  .content-des {
    height: 300px;
    border-color: #dfe1e7;
  }
  .tc {
    text-align: center;
    margin-top: 15%;
  }
  .appl-info {
    margin-top: 40px;
    .el-select {
      width: 100%
    }
    .el-input {
      width: 100%
    }
    .el-textarea {
      width: 100%
    }
  }
  .el-card {
    top: 20px;
    right: 20px;
    left: 20px;
    z-index: 2;
    margin-bottom: 0;
    background-color: #fff;
    /deep/ .el-card__header {
      padding: 0 0 10px 0;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .close {
      margin-top: -30px;
      float: right;
      .svg-icon {
        width: 2em;
        height: 2em;
      }
    }
    /deep/ .el-card__body {
      padding: 0;
    }
    .close-win {
      text-align: center;
      margin: 20px 0 10px 0;
    }
  }
</style>
